/**
 * Created by Gaplo917 on 6/9/2017.
 */
import * as PIXI from 'pixi.js'
import * as Rx from 'rxjs'
import TWEEN from "@tweenjs/tween.js"
import Image from "../../objects/Image";
import R from "../../config/R";
import * as Events from "../../Events";
import {AnimationUtils} from "../../AnimationUtils";
import * as _ from "lodash";
import CustomAnimatedSprite from "../../objects/CustomAnimatedSprite";
import SoundManager from "../../SoundManager";

export class Wood extends PIXI.Container {
  constructor(x, y, resources){
    super()
    this.x = x
    this.y = y

    //const wood = new Image(300,0, resources[R.images.wood.name].texture)
    const woodCutting = new CustomAnimatedSprite(1175, -820, resources, R.spines.axeWood)
    const preFire = new CustomAnimatedSprite(-140,0, resources, R.spines.preFire)
    const fire = new CustomAnimatedSprite(-65,-70, resources, R.spines.fire)

    this.preFire = preFire
    this.fire = fire

    this.woodCutting = woodCutting
    this.woodCutting.alpha = 0
    this.woodCutting.scale.set(0,0)

    woodCutting.playAnimation(R.spines.axeWood.animations.beforeAxe, false)
    this.addChild(woodCutting)

  }

  appear(){
    return Rx.Observable.create((observer) => {

      observer.next()
      observer.complete()
    })
  }

  peckingByPecker(){
    return Rx.Observable.create((observer) => {
      this.woodCutting.alpha = 1
      new TWEEN.Tween(this.woodCutting.scale)
        .to({ x: 1, y: 1 }, 500)
        .start()

      new TWEEN.Tween(this.woodCutting)
        .to({ x: 235, y: -150 }, 2000)
        .onComplete(() => {
          observer.next()
          observer.complete()
        })
        .start()

    })
  }

  cutting(){
    return Rx.Observable.create((obs) => {

      setTimeout(() => {
        this.addChildAt(this.preFire, 0)
        SoundManager.instance.playEffect(R.sounds.level2_movewood)

        this.preFire.playAnimation(R.spines.preFire.animations.settingWood, false, () => {
          this.preFire.playAnimation(R.spines.preFire.animations.idleWood, false)
          obs.next()
          obs.complete()
        })
      },2000)


      this.woodCutting.playAnimation(R.spines.axeWood.animations.axe, false, () => {
        this.removeChild(this.woodCutting)
      })
    })
  }

  onFire(){
    return Rx.Observable.create((obs) => {
      this.addChild(this.fire)
      SoundManager.instance.playEffect(R.sounds.level2_fire)

      this.fire.scale.set(2,3)
      this.fire.playAnimation(R.spines.fire.animations.fire, true)

      obs.next()
      obs.complete()
    })
  }

  addOnClickListener(fn) {
    this.interactive = true
    this.buttonMode = true

    this
      .on('mousedown', () => {
      })
      .on('touchstart', () => {
      })
      .on('mouseout', () => {
      })
      .on('mouseover', () => {
      })
      .on('mouseup', (e) => {
        fn(e)
        this.removeOnClickListener()
      })
      .on('touchend', (e) => {
        fn(e)
        this.removeOnClickListener()
      })
  }

  removeOnClickListener(){
    this.interactive = false
    this.buttonMode = false

    this
      .removeListener('mousedown')
      .removeListener('touchstart')
      .removeListener('mouseup')
      .removeListener('touchend')
  }
}



// WEBPACK FOOTER //
// ./src/game/characters/level2/Wood.js